import type { ScheduledDelivery } from "../api/types";

export function deliveryResult(delivery: ScheduledDelivery) {
  const total = delivery.lines.length;
  const pending = delivery.lines.filter((l) => l.status === "PENDING").length;
  const differences = delivery.lines.filter((l) => l.status !== "PENDING" && (
    l.status === "CONFIRMED_WITH_DIFFERENCE" || l.status === "MISSING" ||
    Number(l.shortageQty) > 0 || Number(l.overageQty) > 0 || Number(l.damagedQty) > 0
  )).length;
  const correct = total - pending - differences;
  if (delivery.status === "CANCELED") return { label: "Canceled", detail: "", tone: "muted" };
  if (!total || pending === total) return { label: "Awaiting delivery check", detail: total ? `${total} ${total === 1 ? "item" : "items"} awaiting check` : "No items", tone: "muted" };
  return {
    label: `${correct}/${total} delivered correctly`,
    detail: [differences ? `${differences} ${differences === 1 ? "difference" : "differences"}` : "", pending ? `${pending} awaiting check` : ""].filter(Boolean).join(" · ") || "No differences",
    tone: differences ? "danger" : pending ? "primary" : "success",
  };
}

export function deliveryVatTotals(delivery: ScheduledDelivery) {
  if (delivery.invoice) return {
    net: delivery.invoice.baseEur ?? delivery.totals.billedEur,
    gross: delivery.invoice.grandTotalEur ?? null,
    expected: false,
  };
  // G-169: the typed gross is the server's sum (null unless every line has one).
  return {
    net: delivery.totals.expectedEur,
    gross: delivery.totals.expectedGrossEur,
    expected: true,
  };
}
